export const ToolType = {
    CAPACITYHEALTH: 'CapacityHealth',
    PCM: 'PCM',
    DCSelection: 'DCSelection',
    AllocationMap: 'AllocationMap'
}